<template>
    <div v-if="hasContent" class="help-block">
        <div class="help-block__inner">
            <div class="help-block__content">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'HelpBlock',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasContent() {
      return !!this.$slots.default
    }
  }
}
</script>

<style lang="sass">
    .help-block
        box-shadow: $standard-elevation
        background: white
        height: 90vh
        width: 100%
        max-width: gridSteps(80)
        padding: gridSteps(5) gridSteps(6)

    .help-block__inner
        display: flex
        flex-flow: column
        overflow-y: auto
        height: 100%

        h3
            margin-top: 0
            margin-bottom: gridSteps(3)
            font-weight: normal

        h4
            margin-top: 0
            margin-bottom: gridSteps(1)
            font-weight: normal
        p
            margin-top: 0
            margin-bottom: gridSteps(2)

        ul
            padding-left: 0

</style>
